import styled from 'styled-components';
import { Stack } from '../stack/index.js';
import { suppressProps } from '../../utils/suppress-props.js';
export const FormElement = styled(Stack)
    .withConfig(suppressProps('defaultValues'))
    .attrs({
    elementType: 'form',
}) ``;
//# sourceMappingURL=form.styles.js.map